import React from 'react';
import css from './list.module.css';
import { Link } from 'react-router-dom';
import Spinner from './spinner';
import { useTranslation } from 'react-i18next';

interface ListDataType {
  id: string;
  value: string;
  transferUrl?: string;
}
interface ListProps {
  data: ListDataType[];
}

function List(props: ListProps) {
  const { t } = useTranslation();

  return (
    <div className={css['list-container']}>
      {props.data.length === 0 ? (
        <div className={css['loading']}>
          <div>{t('Loading')}</div>
          <Spinner visible={true} size="lg" />
        </div>
      ) : (
        <ul className={css['list']}>
          {props.data.map((row) => (
            <li key={row.id}>
              {row.transferUrl ? (
                <Link to={row.transferUrl}>{row.value}</Link>
              ) : (
                row.value
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default List;
